// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pwd-container[data-v-486c581d] {\n  margin-top: -20px;\n  margin-bottom: -20px;\n}\n.pwd-container .label-custome[data-v-486c581d] {\n  display: inline-flex;\n  align-items: center;\n}\n.pwd-container .label-custome span[data-v-486c581d] {\n  font-size: 12px;\n  color: #c6cdd9;\n}", ""]);
// Exports
module.exports = exports;
